import React from 'react';
import { ArrowRight, ChevronRight } from 'lucide-react';
export function HomeHero() {
  return <section className="relative min-h-[85vh] md:min-h-screen flex items-end md:items-center justify-center overflow-hidden bg-black pt-8 md:pt-20" data-id="element-1113">
      {/* Background Image with Enhanced Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-1114">
        <img src="https://cdn.magicpatterns.com/uploads/jKaF6KLm1TqUpuFYhBDM2i/hero2.jpg" alt="Walker's Martial Arts Team" className="w-full h-full object-cover" data-id="element-1115" />
        {/* Lighter overall overlay to show more of the background image */}
        <div className="absolute inset-0 bg-black/30" data-id="element-1116" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" data-id="element-1117" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-transparent" data-id="element-1118" />

        {/* Soft radial gradient behind content area - no hard edges */}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_1200px_800px_at_20%_50%,rgba(0,0,0,0.75)_0%,rgba(0,0,0,0.4)_40%,transparent_70%)]" data-id="element-1119" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-12 md:py-0" data-id="element-1120">
        <div className="max-w-3xl animate-fade-up-in" data-id="element-1121">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#00D4FF]/10 border border-[#00D4FF]/30 text-[#00D4FF] text-sm font-semibold mb-6 backdrop-blur-sm" data-id="element-1122">
            <span className="w-2 h-2 rounded-full bg-[#00D4FF] animate-pulse" data-id="element-1123" />
            Serving Bloomington Since 1999
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight mb-6 tracking-tight drop-shadow-2xl" data-id="element-1124">
            Build <span className="text-[#00D4FF]" data-id="element-1125">Confidence</span>, <br data-id="element-1126" />
            Discipline & Strength
          </h1>

          <p className="text-xl md:text-2xl text-gray-100 mb-8 font-light max-w-2xl leading-relaxed drop-shadow-lg" data-id="element-1127">
            Where families kick together. Experience the life-changing benefits
            of martial arts in our 4,200 sq. ft state-of-the-art facility.
          </p>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-1128">
            <a href="/free-trial" className="group bg-[#00D4FF] text-black px-8 py-4 rounded font-bold text-lg uppercase tracking-wider hover:bg-[#33ddff] transition-all flex items-center justify-center gap-2 shadow-[0_0_20px_rgba(0,212,255,0.4)] hover:shadow-[0_0_30px_rgba(0,212,255,0.6)]" data-id="element-1129">
              Schedule Free Trial
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-1130" />
            </a>

            <a href="#programs" className="group px-8 py-4 rounded font-bold text-lg uppercase tracking-wider text-white border border-white/30 hover:bg-white/10 transition-all flex items-center justify-center gap-2 backdrop-blur-sm" data-id="element-1131">
              View Programs
              <ChevronRight className="w-5 h-5 text-[#00D4FF] group-hover:translate-x-1 transition-transform" data-id="element-1132" />
            </a>
          </div>

          <div className="mt-12 flex items-center gap-8 text-sm text-gray-300 font-medium" data-id="element-1133">
            <div className="flex items-center gap-2" data-id="element-1134">
              <div className="w-1 h-1 bg-[#00D4FF] rounded-full" data-id="element-1135" />
              <span data-id="element-1136">Ages 3 to Adult</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-1137">
              <div className="w-1 h-1 bg-[#00D4FF] rounded-full" data-id="element-1138" />
              <span data-id="element-1139">No Experience Needed</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-1140">
              <div className="w-1 h-1 bg-[#00D4FF] rounded-full" data-id="element-1141" />
              <span data-id="element-1142">Family Discounts</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}